export const checkContactType = (contactTypesForLob, contactTypeFromParam) => {
    for (const key in contactTypesForLob) {
        if (contactTypesForLob.hasOwnProperty(key)) {
            const contactType = contactTypesForLob[key];
            if (contactType === contactTypeFromParam) {
                return true;
            }
        }
    }
    return false;
};

export const getImageUrl = (imageUrl) => `data:image/png;base64, ${imageUrl}`;
